import { Baby, Gift, CalendarCheck } from "@phosphor-icons/react";
import { StartFreeButton, Eyebrow } from "@/components/landing/shared";

const POINTS = [
  { icon: CalendarCheck, t: "10 days free", d: "Explore the Childhood season free for 10 days. No card needed to begin." },
  { icon: Baby, t: "Start where it began", d: "Childhood is the perfect first chapter — school days, family traditions, first friends and favourite places." },
  { icon: Gift, t: "One gift from us", d: "Record five meaningful Childhood memories and we'll give you one complimentary Memory Insight on a Childhood memory you choose." },
];

export const ChildhoodFree = () => (
  <section data-testid="childhood-free" className="px-4 sm:px-6">
    <div className="mx-auto max-w-6xl rounded-[28px] bg-[#FFF4F0] p-6 ring-1 ring-[#F7C4B8] sm:p-10">
      <Eyebrow>Start Childhood free</Eyebrow>
      <h2 className="mt-3 max-w-2xl font-serif text-3xl leading-snug text-[#2D2824] sm:text-4xl">Your story begins in Childhood</h2>
      <div className="mt-8 grid gap-5 md:grid-cols-3">
        {POINTS.map((p) => (
          <div key={p.t} className="rounded-2xl bg-white p-5 shadow-sm transition-transform hover:-translate-y-1">
            <span className="inline-flex h-11 w-11 items-center justify-center rounded-full bg-[#E06D53]/10 text-[#E06D53]">
              <p.icon size={22} weight="duotone" />
            </span>
            <h3 className="mt-4 font-serif text-xl text-[#2D2824]">{p.t}</h3>
            <p className="mt-1.5 text-sm leading-relaxed text-[#6E665E]">{p.d}</p>
          </div>
        ))}
      </div>
      <p data-testid="complimentary-note" className="mt-6 text-sm leading-relaxed text-[#6E665E]">
        The complimentary Memory Insight is a one-time gift — one insight in total. Further Memory Insights are optional paid extras.
      </p>
      <StartFreeButton testId="childhood-start" className="mt-6" />
    </div>
  </section>
);
